<template>
  <div class="card" v-if="leilao">
    <div
      @click="redirectLeilao()"
      class="card-body"
      style="padding: 0px 0px 0px 0px; text-align: left; font-family: 'Montserrat', sans-serif; text-transform: uppercase; margin: 0px 0px 0px 0px"
    >
      <div style="text-align: left; line-height: 16px; margin-top: -11px" class="p-2">
        <div style="margin-top: 7px; position: relative">
          <span style="font-size: 16px; font-weight: bold; word-wrap: break-word">{{ leilao.cidade }} - {{ leilao.estado }}</span>
          <br />
          <span style="font-size: 15px; font-weight: bold">
            {{ getFormatedTitle(leilao.leilao_titulo) }}
          </span>
        </div>
      </div>

      <!-- LOTE CONTAGEM 
        <div style="text-align: left; line-height: 1px; text-align: left" class="p-2">
          <div style="margin-top: 18px; margin-bottom: 7px !important">
            <p style="font-size: 15px; color: #4a4949; font-weight: bold; margin-top: 4px">
              {{ getFormatedTitle(leilao.leilao_titulo) }}
            </p>
          </div>
        </div>
        -->

      <div style="line-height: 15px; text-align: left; margin-top: -10px" class="p-2">
        <b style="font-size: 14px">
          Modalidade:
          <a style="color: #4a4949; font-weight: 400">{{ leilao.leilao_1_modalidade }}</a>
        </b>
        <br />
        <b style="font-size: 14px">
          Local:
          <a style="color: #4a4949; font-weight: 400; text-transform: uppercase">{{ leilao.leilao_local }}</a>
        </b>
        <!--
        <div v-if="leilao.processo">
          <b style="font-size: 14px">
            Processo:
            <a style="color: #4a4949; font-weight: 400; text-transform: none">{{ leilao.processo.processo_numero }}</a>
          </b>
          <br />
          <b style="font-size: 14px">
            Comitente:
            <a style="color: #4a4949; font-weight: 400">{{ getFormatedComitente(leilao) }}</a>
            <!--
            <a style="color: #4a4949; font-weight: 400">{{ leilao.processo.processo_vara }}</a>
            <a v-if="leilao.processo.cidade" style="color: #4a4949; font-weight: 400">- {{ leilao.processo.cidade.nome }}</a>
            <a v-if="leilao.processo.estado" style="color: #4a4949; font-weight: 400">- {{ leilao.processo.estado.sigla }}</a>
           
              </b>
        </div>
            -->

        <div v-if="leilao.comitente">
          <b style="font-size: 14px">
            Comitente:
            <a style="color: #4a4949; font-weight: 400">{{ getFormatedComitente(leilao) }}</a>
          </b>
          <br />
          <br />
        </div>
        <div v-else>
          <br />
          <br />
        </div>
      </div>
      <!-- DATAS E VALORES DOS LEILÕES -->
      <div
        v-if="leilao.leilao_num_pracas > 1 && !venda_direta"
        style="padding-bottom: 0px !important; text-align: left; line-height: 15px; margin-top: -10px"
        class="p-2"
      >
        <div style="font-size: 14px; color: #545353" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
          <b>1º Leilão:</b>
          {{ formatDate(leilao.leilao_1_data) + "h" }}
        </div>

        <!-- DATA 2 -->
        <div style="font-size: 14px; color: #545353" v-if="leilao.leilao_num_pracas >= 2" :class="leilao.leilao_2_realizado === 1 ? 'realizado' : ''">
          <b>2º Leilão:</b>
          {{ formatDate(leilao.leilao_2_data) + "h" }}
        </div>

        <div style="font-size: 14px; color: #545353" v-else><br /></div>

        <!-- DATA 3 -->
        <div style="font-size: 14px; color: #545353" v-if="leilao.leilao_num_pracas >= 3" :class="leilao.leilao_3_realizado === 1 ? 'realizado' : ''">
          <b>3º Leilão:</b>
          {{ formatDate(leilao.leilao_3_data) + "h" }}
        </div>

        <div style="font-size: 14px; color: #545353" v-else><br /></div>

        <!-- DATA 4 -->
        <div style="font-size: 14px; color: #545353" v-if="leilao.leilao_num_pracas >= 4" :class="leilao.leilao_4_realizado === 1 ? 'realizado' : ''">
          <b>4º Leilão:</b>
          {{ formatDate(leilao.leilao_4_data) + "h" }}
        </div>

        <div style="font-size: 14px; color: #545353" v-else><br /></div>
      </div>

      <!-- ÚNICO LEILÃO-->
      <div
        v-else-if="leilao.leilao_num_pracas == 1 && !venda_direta"
        style="padding-bottom: 0px !important; padding-left: 8px !important; text-align: left; line-height: 15px; margin-top: -5px"
        class="p-1"
      >
        <div style="font-size: 14px; color: #545353; margin-bottom: 3px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
          <b>Único leilão:</b>
          {{ formatDate(leilao.leilao_1_data) + "h" }}
        </div>
        <br />
        <br />
        <br />
      </div>

      <!-- ÚNICO LEILÃO-->
      <div
        v-else-if="leilao.leilao_num_pracas == 1 && !venda_direta"
        style="padding-bottom: 0px !important; padding-left: 8px !important; text-align: left; line-height: 15px; margin-top: -5px"
        class="p-1"
      >
        <div style="font-size: 14px; color: #545353; margin-bottom: 3px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
          <b>Único leilão:</b>
          {{ formatDate(leilao.leilao_1_data) + "h" }}
        </div>
        <br />
        <br />
        <br />
      </div>

      <!-- ÚNICO LEILÃO-->
      <div
        v-else-if="venda_direta"
        style="padding-bottom: 0px !important; padding-left: 8px !important; text-align: left; line-height: 15px; margin-top: -5px"
        class="p-1"
      >
        <div style="font-size: 14px; color: #545353; margin-bottom: 3px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
          <b>Disponível até:</b>
          {{ formatDate(leilao.leilao_1_data) + "h" }}
        </div>
        <br />
        <br />
        <br />
      </div>

      <!-- ID DO LEILÃO-->
      <span class="p-2" style="font-size: 15px; font-weight: bold; padding-top: 0px !important">Leilão ID {{ leilao.id }}</span>
    </div>
  </div>
</template>

<script>
import wppController from "../../controller/wppController";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";
import currencyController from "../../controller/currencyController";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [wppController, sweetAlert, Swal, currencyController],

  props: ["leilao", "index"],

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      lote_selecionado: "",
      indice_lote: "",
      imagem_lote: "",
      venda_direta: "",
      texto_btn: "",
      fade: false,
    };
  },

  mounted() {
    if (this.leilao.lotes.length) {
      this.lote_selecionado = this.leilao.lotes[0];
      this.indice_lote = 0;

      this.buscarImagemLote();
      this.buscarUltimaPraca();

      console.log("Primeiro lote do leilão " + this.leilao.leilao_titulo + " = " + this.lote_selecionado.id);
      console.log(this.lote_selecionado);
    }

    if (this.leilao.leilao_1_modalidade == "venda") {
      this.venda_direta = true;
    }

    console.log("Todos os lotes do leilão " + this.leilao.leilao_titulo);
    console.log(this.leilao);
    console.log(this.leilao.lotes);
  },

  methods: {
    getFormatedComitente(leilao) {
      let texto = "";

      texto = leilao.comitente.nome;

      if (leilao.comitente && leilao.comitente.cidade && leilao.comitente.estado) {
        texto = texto + " - " + leilao.comitente.cidade.nome + " - " + leilao.comitente.estado.sigla;
      }

      /*

      if (leilao.leilao_tipo == "judicial" && leilao.processo) {
        texto = leilao.processo.processo_vara;

        if (leilao.processo.cidade) {
          texto = texto + " - " + leilao.processo.cidade.nome + " - " + leilao.processo.estado.sigla;
        }

        if (leilao.processo.estado) {
          texto = texto + " - " + leilao.processo.cidade.nome + " - " + leilao.processo.estado.sigla;
        }
      } else if (leilao.comitente) {
        console.log("COMITENTE ELSE");

        texto = leilao.comitente.nome;

        if (leilao.comitente && leilao.comitente.cidade && leilao.comitente.estado) {
          texto = texto + " - " + leilao.comitente.cidade.nome + " - " + leilao.comitente.estado.sigla;
        }
      }
      */

      if (texto && texto.length > 30) {
        return texto.substring(0, 30) + "...";
      } else {
        return texto;
      }
    },

    redirectLeilao() {
      if (this.leilao.lotes && this.leilao.lotes.length > 1) {
        window.open("/leilao/" + this.leilao.id + "/lotes?origin=agenda", "_self");
      } else {
        window.open("/lote/" + this.leilao.lotes[0].id + "?origin=agenda", "_self");
      }
    },

    getUrlLeilao() {
      if (this.leilao.lotes && this.leilao.lotes.length > 1) {
        return "/leilao/" + this.leilao.id + "/lotes";
      } else {
        return "/lote/" + this.leilao.lotes[0].id;
      }
    },

    getFormatedTitle(title) {
      if (title && title.length > 30) {
        return title.substring(0, 30) + "...";
      } else {
        return title;
      }
    },

    proximoLote(indice) {
      console.log("Indice " + indice);
      console.log("Length " + this.leilao.lotes.length);

      if (indice < this.leilao.lotes.length && indice >= 0) {
        this.lote_selecionado = this.leilao.lotes[indice];
        this.indice_lote = indice;

        this.buscarImagemLote();
        this.buscarUltimaPraca();
      } else {
        this.showErrorMessageWithButton("Ops...", "Este é o último lote");
      }
    },

    buscarUltimaPraca() {
      if (this.lote_selecionado) {
        if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
          this.venda_direta = this.leilao.leilao_2_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_1_data, this.leilao.leilao_1_modalidade);
        } else if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
          this.venda_direta = this.leilao.leilao_2_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_2_data, this.leilao.leilao_2_modalidade);
        } else if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
          this.venda_direta = this.leilao.leilao_3_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_3_data, this.leilao.leilao_3_modalidade);
        } else if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
          this.venda_direta = this.leilao.leilao_4_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_4_data, this.leilao.leilao_4_modalidade);
        } else {
          //CASO NENHUMA PRAÇA TENHA SIDO REALIZADA AINDA
          this.gerarTexto(this.leilao.leilao_1_data, this.leilao.leilao_1_modalidade);
        }
      }

      console.log("Venda direta lote " + this.lote_selecionado.id + " ? " + this.venda_direta);
    },

    gerarTexto(data_proxima_praca, modalidade) {
      if (modalidade != "venda") {
        let data = this.formatDateNew(data_proxima_praca);

        if (data != "Invalid date") {
          let vencido = new Date() >= new Date(data_proxima_praca);

          if (vencido) {
            this.texto_btn = "Aberto para lances";
          } else {
            this.texto_btn = "Em breve";
          }
        }
      } else {
        this.texto_btn = "Venda direta";
      }
    },

    formatDateNew(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },

    buscarImagemLote() {
      this.imagem_lote = this.lote_selecionado.thumb;
    },

    getLeilaoPath() {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.leilao.path + "/" + this.leilao.arquivo;
    },

    getImagePath() {
      if (this.imagem_lote) {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.imagem_lote.path + "/" + this.imagem_lote.img;
      } else {
        return "/images/logo.png";
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else if (!this.validateEmail()) {
        this.showErrorMessageWithButton("Ops...", "Digite um email válido!");
      } else if (this.senha == "") {
        this.showErrorMessageWithButton("Ops...", "A senha não pode ficar em branco!");
      } else {
        this.create();
      }
    },

    create() {
      this.isLoading = true;

      let data = {
        nome: this.nome,
        email: this.email,
        senha: this.senha,
        chave: this.generateKey(),
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/users/create`, data)
        .then((response) => {
          console.log("Usuário criado!");
          console.log(response);

          this.showSuccessMessage("Usuário criado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.ic:hover {
  transition-duration: 500ms;
  transform: scale(1.2);
  color: #696969;
}

h5 {
  font-size: 18px;
  color: #4a4949;
}

.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}

.im-logo {
  -o-object-fit: cover;
  object-fit: cover;
}

.arrow-pass:hover {
  opacity: 0.7;
}

.realizado {
  text-decoration: line-through;
}

.btn-yellow {
  background-color: #f7de5e;
  border-color: #f7de5e;
  color: white;
}

.back-yellow {
  background-color: #f7de5e;
  border-color: #f7de5e;
  color: #301904;
}

.back-brown {
  background-color: #301904;
  color: white;
}
</style>
